import WantedScoutButtonMixin from 'modules/mixins/WantedScoutButton';

// お気に入り
export default class WantedScoutButton {
  constructor(els) {
    this.els = els;
    this.els.forEach((el) => this.initialize(el));
  }

  initialize(el) {
    new Vue({
      el,
      name: 'WantedScoutButton',
      mixins: [WantedScoutButtonMixin],
    });
  }
}
